export const topButtonStyle =
    "py-2 px-4 rounded-full text-sm bg-background-highlight";
export const topButtonSelectedStyle =
    "bg-spotify-green text-black py-2 px-4 rounded-full text-sm";